'use strict'

FancyDropDown = require '../../fancy_drop_down/frontend/fancy_drop_down'

module.exports = class OffersMapFilters

  onChangeCallbacks: []

  templates:
    main: require '../main.html.mustache'

  constructor: ({ el, @config, @history }) ->
    @$el = $ el

    @render()

    @$filters = @$el.find '.offers-map-filters'
    @$deals = @$el.find '.filter-by-deals input'
    @$onlineOrdering = @$el.find '.filter-by-online-ordering input'
    @$openNow = @$el.find '.filter-by-open-now input'

    @history.onPop @historyHandler

  render: ->
    data = { config: @config }
    data.translate = data.t = -> (str) -> I18n.t str
    @$el.html @templates.main.render data

    sortByOptions = [{
      text: I18n.t 'js.modules.offers_map_filters.sort_by.relevance'
      value: 'relevance'
      isSelected: true
    }, {
      text: I18n.t 'js.modules.offers_map_filters.sort_by.best_rated'
      value: 'rating'
    }, {
      text: I18n.t 'js.modules.offers_map_filters.sort_by.distance'
      value: 'distance'
    }]

    @sortByDropDown = new FancyDropDown {
      el: @$el.find('.sort-by-drop-down')
      options: sortByOptions
    }

    @sortByDropDown.onChange @triggerChange
    @$el.find('input').change @triggerChange

    @$el.find('.icon-x').click => @hideMobileModal()

    @$el

  historyHandler: ({ action }) =>
    if action is 'filters-show-modal'
      @showMobileModal false
    else if action is 'filters-hide-modal' or @$filters.hasClass 'show-phone-modal'
      @hideMobileModal false

  showMobileModal: (saveInHistory = true) ->
    @$filters.addClass 'show-phone-modal'
    @history.add({ action: 'filters-show-modal' }) if saveInHistory

  hideMobileModal: (saveInHistory = true) ->
    @$filters.removeClass 'show-phone-modal'
    @history.add({ action: 'filters-hide-modal' }) if saveInHistory

  triggerChange: =>
    cb() for cb in @onChangeCallbacks

  onChange: (cb) ->
    @onChangeCallbacks.push cb

  values: ->
    deals = @$deals.is ':checked'
    onlineOrdering = @$onlineOrdering.is ':checked'
    openNow = @$openNow.is ':checked'

    count = 0
    count += 1 for filter in [deals, onlineOrdering, openNow] when filter is true

    {
      deals,
      onlineOrdering,
      openNow,
      count,
      sortBy: @sortByDropDown.value()
    }

  clear: ->
    $checked = @$el.find 'input:checked'
    shouldTriggerChange = $checked.length > 0
    $checked.attr 'checked', false
    @triggerChange() if shouldTriggerChange
